export default class TraineeAddController {
    constructor($routeParams, $location, userService, notificationsService, globalConstants) {
        this.$location = $location;
        this.userService = userService;
        this.$location = $location;
        this.globalConstants = globalConstants;
        this.clientId = $routeParams.clientId;
        this.user = {
            icon: 'default1.png'
        };
        this.user.clientId = $routeParams.clientId;
        this.imageData = undefined;
        this.notificationsService = notificationsService;
    } 

    onSave() { 

        var that = this;

        if(this.user.name == undefined || this.user.name.length < 1 || 
            this.user.email == undefined || this.user.email.length < 1 ||
            this.user.password == undefined || this.user.password.length < 1){
            this.notificationsService.show("Please enter a name, email and password", "error");
            return;
        }

        if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)){
            this.notificationsService.show("Please enter a valid email address", "error");
            return;
        }

        if(that.imageData != undefined) {
            that.user.image = that.imageData.image;
            that.user.imagetype = that.imageData.imagetype;
        }

        that.userService.insertTrainee(that.user).then(resp => {
            that.$location.path(`/manage/clients/edit/` + that.clientId);
            that.notificationsService.show("Trainee added", "success");
        }, 
            resp => {
                that.notificationsService.show(resp.data, "error");
        });
    }

    clearImageUpload() {
        document.getElementById('file').value = null;
        this.imageData = undefined;
    }

    goBack(){
        this.$location.path(`/manage/clients/edit/` + this.clientId);
    }
}


// WEBPACK FOOTER //
// ./src/js/components/trainees/trainees.add.controller.js